import styled from "styled-components";
import * as BackgroundStyles from "../../../common/styles/BackgroundStyles";
import { focusStyle } from "../../../../../../../../common-deprecated/styles/v2/toyota/utilities/Focus";
import { theme } from "../../../../../../../../common-deprecated/styles/v2/toyota/theme/toyotaTheme";

/**
 * Shared styles for a "popup list" which contains a clickable list of button options.
 */
export const Wrapper = styled(BackgroundStyles.Shadow)`
    position: absolute;
    right: 0;
    min-width: 256px;
    z-index: ${theme.zIndex.popup};
`;

export const Button = styled.button`
    width: 100%;
    min-height: 50px;
    margin: 0;
    padding: 0;
    padding-left: ${theme.space[2]}px;
    text-align: start;
    color: ${theme.colors.grey4};
    background: none;
    border: none;
    border-bottom: 1px solid ${theme.colors.grey1};
    ${focusStyle};

    html[dir="rtl"] & {
        padding-right: ${theme.space[2]}px;
    }
`;

export const Item = styled.div``;

export const ItemRow = styled.div`
    &:last-child {
        ${Button} {
            border-bottom: none;
        }
    }
`;
